/**
 * Module dependencies
 */

import { DateTime } from 'luxon';

/**
 * Export `formatStringToDate` util.
 */

export function formatStringToDate(stringDate: null | string | undefined, pattern = `dd LLL yyyy '-' HH:mm`) {
  if (!stringDate) {
    return undefined;
  }

  try {
    return (
      DateTime.fromISO(stringDate)
        .setLocale('pt')
        .toFormat(pattern)
        // PT translation for short month names includes a dot (jul.).
        .replace('.', '')
    );
  } catch {
    return undefined;
  }
}
